import React from 'react'

export const PdfFile = () => {
  return (
    <svg fill='none' height='40' viewBox='0 0 40 40' width='40' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M14 2.5H26.3428C27.271 2.5 28.162 2.86901 28.8184 3.52539L36.4746 11.1816C37.131 11.838 37.5 12.729 37.5 13.6572V34C37.5 35.933 35.933 37.5 34 37.5H14C12.067 37.5 10.5 35.933 10.5 34V6C10.5 4.067 12.067 2.5 14 2.5Z'
        stroke='#CAC2D6'
      />
      <path d='M27 3V9C27 11.2091 28.7909 13 31 13H37' stroke='#CAC2D6' />
      <path
        d='M2 29C2 30.6569 3.34315 32 5 32H23C24.6569 32 26 30.6569 26 29V22C26 20.3431 24.6569 19 23 19H5C3.34315 19 2 20.3431 2 22V29Z'
        fill='#FF2450'
      />
      <path
        d='M5.8 22H6.65V29H5.8V22ZM6.27 22.8V22H7.7C8.15333 22 8.55667 22.0867 8.91 22.26C9.27 22.4267 9.55333 22.6667 9.76 22.98C9.97333 23.2933 10.08 23.6667 10.08 24.1C10.08 24.5267 9.97333 24.9 9.76 25.22C9.55333 25.5333 9.27 25.7767 8.91 25.95C8.55667 26.1167 8.15333 26.2 7.7 26.2H6.27V25.4H7.7C8.15333 25.4 8.52 25.29 8.8 25.07C9.08667 24.85 9.23 24.5267 9.23 24.1C9.23 23.6667 9.08667 23.3433 8.8 23.13C8.52 22.91 8.15333 22.8 7.7 22.8H6.27Z'
        fill='white'
      />
      <path
        d='M11.3585 22H12.2085V29H11.3585V22ZM13.4585 29H11.8285V28.15H13.4585C13.8518 28.15 14.2118 28.09 14.5385 27.97C14.8652 27.8433 15.1452 27.6667 15.3785 27.44C15.6118 27.2067 15.7918 26.9267 15.9185 26.6C16.0452 26.2733 16.1085 25.9067 16.1085 25.5C16.1085 25.0933 16.0452 24.7267 15.9185 24.4C15.7918 24.0733 15.6118 23.7967 15.3785 23.57C15.1452 23.3367 14.8652 23.16 14.5385 23.04C14.2118 22.9133 13.8518 22.85 13.4585 22.85H11.8285V22H13.4585C14.1385 22 14.7418 22.1467 15.2685 22.44C15.7952 22.7333 16.2085 23.1433 16.5085 23.67C16.8085 24.19 16.9585 24.8 16.9585 25.5C16.9585 26.2 16.8085 26.8133 16.5085 27.34C16.2085 27.86 15.7952 28.2667 15.2685 28.56C14.7418 28.8533 14.1385 29 13.4585 29Z'
        fill='white'
      />
      <path
        d='M18.7054 22.8V22H21.8354V22.8H18.7054ZM18.7054 25.6V24.8H21.7354V25.6H18.7054ZM18.2354 22H19.0854V29H18.2354V22Z'
        fill='white'
      />
    </svg>
  )
}